<template>
  <div>
    <!-- SE FOR JOGO -->
    <template v-if="isMobile">
      <div class=" alert-free-game">
        <!-- <div v-if="backButton" @click="back()" class="col-md-1 back-button">
          <i class="fa fa-caret-left mr-1"></i>
          <span class="title">VOLTAR</span>
        </div> -->

        <div class=" infosContentTitle">
          <div>
            <span class="title">{{ screenName }}</span>
          </div>
          <div>
          </div>
        </div>

        <!-- <div class="col-md-4 menu">
          <template v-if="plan && logado">
            <div class="textUpgrade">
              <span class="title">{{
                plano_detalhes[0] ? plano_detalhes[0].planos.nome : "gratuito"
              }}</span
              ><button @click="$router.push({ path: '/assinatura/planos' })">
                Faça upgrade
              </button>
            </div>
          </template>
          <template v-else>
            <div class="textUpgrade">
              <span class="title" v-if="text">{{ text }}</span>
              <button v-if="callback" @click="callback()">
                {{ callbackText }}
              </button>
            </div>
          </template>
        </div> -->

        <!-- <div class="col-md-3 infosContentPoints">
          <div class="iconMargin">
            <i class="fa fa-clock-o mr-2"></i>
            <span>{{ timer }} </span>
          </div>
          <div class="iconMargin">
            <i class="fa fa-trophy"> </i> <span> {{ points }} PTS</span>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-center align-items-center">
          <span @click="menuFunction()" class="optionButton">Menu</span>
        </div> -->
      </div>
    </template>
    
    <template v-else>
      <div class="row alert-free">
        <div v-if="backButton" @click="back()" class="col-md-1 back-button">
          <i class="fa fa-caret-left mr-1"></i>
          <span>VOLTAR</span>
        </div>
        <div class="col-md-11 screenName"> 
          <span class="title" v-if="screenName">{{ screenName }}</span>
        </div>
        <!-- <div class="col-md-10 menu">
          <template v-if="plan && logado">
            <div>
              <span>{{
                plano_detalhes[0] ? plano_detalhes[0].planos.nome : "gratuito"
              }}</span
              ><button @click="$router.push({ path: '/assinatura/planos' })">
                Faça upgrade
              </button>
            </div>
          </template>
          <template v-else>
            <div>
              <span v-if="text">{{ text }}</span>
              <button v-if="callback" @click="callback()">
                {{ callbackText }}
              </button>
            </div>
          </template>
        </div> -->
      </div>
    </template>
  </div>
</template>
<script>
// import decode from "jwt-decode";

export default {
  name: "AlertaPlano",
  props: {
    callback: Function,
    menuFunction: Function,
    saveFunction: Function,
    text: String,
    title: String,
    passatempoId: String,
    subTitle: String,
    callbackText: String,
    plan: Boolean,
    isMobile: Boolean,
    timer: String,
    points: Number,
    backButton: Boolean,
    backButtonGame: Boolean,
    screenName: String,
  },
  data: () => ({
    plano_detalhes: {},
    logado: false,
  }),
  mounted() {
    if (this.plan && localStorage.getItem("t")) {
      this.logado = true;
      this.mount();
    }
  },
  methods: {
    async back() {
      // if (this.backButton && this.backButtonGame) {
      //   await this.$store.commit("setStateModal", {
      //     visible: true,
      //     title: "Que pena!",
      //     type: "warning",
      //     message: "Deseja mesmo sair do jogo?",
      //     callbackOk: async () => {
      //       this.saveFunction();
      //       this.$router.back();
      //       this.$store.commit("jogo", false);
      //     },
      //     callbackCancel: () =>
      //       this.$store.commit("setStateModal", { visible: false }),
      //   });
      // } else {
      //   this.$router.back();
      // }

      this.$router.back();
      // this.$router.replace('/');
    },
    mount() {
      // if (localStorage.getItem("t")) {
      //   let id = decode(localStorage.getItem("t")).usr.id;
      //   this.$axios
      //     .get(`/users/${id}/assinaturas`)
      //     .then((res) => res.data)
      //     .then((res) => {
      //       this.plano_detalhes = res;
      //     })
      //     .catch((err) => {
      //       this.$store.commit("setStateModal", {
      //         visible: true,
      //         title: "ATENÇÃO",
      //         type: "warning",
      //         message: err.response.data.message,
      //       });
      //     });
      // }
    },
  },
};
</script>
<style scoped>
.alert-free {
  background-color: rgb(22, 22, 22);
  height: 14vh;
  width: 100%;
  color: white;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999 !important;
  font-size: 18px;
  text-transform: uppercase;
  position: relative;
  font-weight: bold;
}
.alert-free-game {
  height: 5vh;
  width: 70%;
  margin-left: 15%;
  color: white;
  z-index: 999999 !important;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.textUpgrade {
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu {
  height: 100%;
  width: 100%;

  color: white;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999 !important;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;
}
.screenName{
  display: flex;
  justify-content: center;
  align-items: center;
}
.back-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  cursor: pointer;
}

.alert-free button {
  border: none;
  letter-spacing: 2px;
  padding: 1px 10px;
  font-size: 16px;
  margin-left: 20px;
  background-color: #4e9c5f;
  color: white;
  font-weight: bold;

  text-transform: uppercase;
}
.alert-free-game button {
  border: none;
  letter-spacing: 2px;
  padding: 1px 10px;
  font-size: 18px;
  margin-left: 20px;
  background-color: #4e9c5f;
  color: white;
  font-weight: bold;

  text-transform: uppercase;
}

.infosContentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 18.5vh;  
  width: 100%;
  height: 100%;
}
.infosContentPoints {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 18px;
}
.iconMargin {
  margin-right: 10px;
}
.title {
  font-size: 30px;
  text-transform: uppercase;
}
.optionButton {
  font-size: 18px;
  text-transform: uppercase;
  cursor: pointer;
}
.infosContentTitle .sub-title {
  font-size: 13px;
  font-family: "Agency FB Regular";
}
@media only screen and (max-width: 1300px) {
  .title {
    font-size: 16px;
  }
  .menu {
    font-size: 16px;
  }
  .infosContentPoints {
    font-size: 16px;
  }
}
</style>